import { NavDropdownType, NavUtilPrimaryLinkType } from 'components/navV2/types';

const hasChildren = (
  node: NavUtilPrimaryLinkType | NavDropdownType | undefined
): node is NavDropdownType =>
  !!node && 'children' in node && Array.isArray(node.children) && node.children.length > 0;

export default hasChildren;
